var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8721 22.875H55.1029V52.875H19.8721V22.875Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4433 13L15 25.5V50.5L37.4433 63L59.8867 50.5V25.5L37.4433 13ZM20.0944 36.8139H32.2405L32.2472 39.1905H20.0944V36.8139ZM22.9512 41.1615H35.7437L39.1588 34.845H22.9512V32.4684H43.2226L37.2377 43.5403H22.9512V41.1615ZM50.2245 46.2832C48.5497 48.6729 46.215 50.5262 43.4712 51.6469C42.5242 52.0306 41.5478 52.325 40.5511 52.519C39.5521 52.7131 38.5305 52.8112 37.4976 52.8112H27.1461V46.0586H30.3126V49.7543H37.4953C39.9363 49.7543 42.2914 49.061 44.3074 47.7484C46.2738 46.4642 47.8016 44.6763 48.7215 42.5766C49.3566 41.131 49.6798 39.5895 49.6798 38.0022C49.6798 35.6474 48.9611 33.3755 47.6005 31.4328C46.2715 29.5337 44.4182 28.0619 42.2394 27.1723C40.7386 26.5597 39.143 26.25 37.4976 26.25H30.3148V29.9937H27.1483V23.1932H37.4976C40.5759 23.1932 43.5435 24.0697 46.0817 25.7246C48.5588 27.3359 50.4822 29.5925 51.6416 32.2395C52.4417 34.0666 52.8486 36.005 52.8486 38.0044C52.8508 40.9718 51.9422 43.8346 50.2268 46.2854L50.2245 46.2832Z",
    fill: "#F10025"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_186",
    x: 0,
    y: 0,
    width: 74.8867,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_186"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_186",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/app-logo.da8d8b8ceae0de95e206cd98dc91cc87.svg";
export { ForwardRef as ReactComponent };